import Enumerable from '@ember/enumerable';
import Mixin from '@ember/object/mixin';
const MutableEnumerable = Mixin.create(Enumerable);
export default MutableEnumerable;